import {
  CalendarOutlined,
  FileTextOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Card, Col, Progress, Row, Statistic } from 'antd';
import dayjs from 'dayjs';
import styles from 'styles/components/cyclesStatistics.module.scss';

const CyclesStatistics = ({ cycle }) => {
  const daysTotal = dayjs(cycle.deadline).diff(dayjs(cycle.startedAt), 'day');
  const daysPassed = dayjs().diff(dayjs(cycle.startedAt), 'day');

  const colSpacing = { xs: 24, sm: 12, md: 8, lg: 8 };

  return (
    <div className={styles.statisticsWrapper}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col {...colSpacing}>
          <Card variant="borderless" className={styles.statisticCard}>
            <Statistic
              title={
                <div>
                  <FileTextOutlined /> Reviews collected
                </div>
              }
              value={cycle.stats.reviewsCount}
              valueStyle={
                cycle.stats.reviewsCount === cycle.stats.reviewsTotal
                  ? { color: '#3f8600' }
                  : {}
              }
              suffix={`/ ${cycle.stats.reviewsTotal}`}
            />
            <div>
              <Progress
                percent={(
                  (cycle.stats.reviewsCount / cycle.stats.reviewsTotal) *
                  100
                ).toFixed(0)}
                size="small"
                status={
                  cycle.stats.reviewsCount < cycle.stats.reviewsTotal
                    ? 'active'
                    : ''
                }
              />
            </div>
          </Card>
        </Col>
        <Col {...colSpacing}>
          <Card variant="borderless" className={styles.statisticCard}>
            <Statistic
              title={
                <div>
                  <UserOutlined /> Employee reviewed
                </div>
              }
              value={cycle.stats.usersCount}
              valueStyle={
                cycle.stats.usersCount === cycle.stats.usersTotal
                  ? { color: '#3f8600' }
                  : {}
              }
              suffix={`/ ${cycle.stats.usersTotal}`}
            />
            <div>
              <Progress
                percent={(
                  (cycle.stats.usersCount / cycle.stats.usersTotal) *
                  100
                ).toFixed(0)}
                size="small"
                status={
                  cycle.stats.usersCount < cycle.stats.usersTotal
                    ? 'active'
                    : ''
                }
              />
            </div>
          </Card>
        </Col>
        <Col {...colSpacing}>
          <Card variant="borderless" className={styles.statisticCard}>
            <Statistic
              title={
                <div>
                  <CalendarOutlined /> Days passed
                </div>
              }
              value={daysPassed}
              suffix={`/ ${daysTotal}`}
            />
            <div>
              <Progress
                percent={((daysPassed / daysTotal) * 100).toFixed(0)}
                size="small"
                status={daysPassed < daysTotal ? 'active' : ''}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CyclesStatistics;
